import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { MatDialogContent, MatDialogRef } from '@angular/material/dialog';
import { ModalComponent } from '../../../../../../shared/components/dialogs/modal/modal.component';
import { SelectingValueDataComponent } from '../../../shared/selecting-value-data/selecting-value-data.component';
import { ValueDataModel } from '../../../../models/ValueData.model';

@Component({
  selector: 'app-add-series-modal',
  imports: [ModalComponent, MatDialogContent, SelectingValueDataComponent],
  templateUrl: './add-series-modal.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './add-series-modal.component.scss',
})
export class AddSeriesModalComponent {
  private dialogRef = inject<MatDialogRef<AddSeriesModalComponent>>(MatDialogRef);

  data: ValueDataModel = { valueId: null, loggerId: null, deviceId: null };

  valueSelected() {}

  isValid() {
    return this.data && this.data.loggerId && this.data.valueId;
  }

  onSave() {
    this.dialogRef.close(this.data);
  }
}
